import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  infoTitleStyle: {
    marginTop: 42,
    marginBottom: 12,
    alignSelf: 'center',
    color: colors.darkGrey,
    fontSize: 24,
  },
  infoTextStyle: {
    alignSelf: 'center',
    color: colors.darkGrey,
    fontSize: 16,
    textAlign: 'center',
  },
});
